export enum TenantsEnum {
  Beesafe = 'beesafe',
  Benefia = 'benefia',
  Compensa = 'compensa',
  Wiener = 'wiener',
  Interrisk = 'interrisk',
}

export type Tenants = `${TenantsEnum}`;
